/* Location ValueSets and constants */

export const LOCATION_STATUS = {
  definingURL: 'http://hl7.org/fhir/ValueSet/location-status',
  version: '4.3.0',
  name: 'LocationStatus',
  title: 'Location Status',
  definition: 'Indicates whether the location is still in use',
  values: [
    {
      code: 'active',
      display: 'Active',
      definition: 'The location is operational.',
    },
    {
      code: 'suspended',
      display: 'Suspended',
      definition: 'The location is temporarily closed.',
    },
    {
      code: 'inactive',
      display: 'Inactive',
      definition: 'The location is no longer used.',
    },
  ],
};

// http://terminology.hl7.org/ValueSet/v2-0116
export const LOCATION_OPERATIONAL_STATUS = {
  definingURL: 'http://terminology.hl7.org/ValueSet/v2-0116',
  version: '2.0.0',
  name: 'Hl7VSBedStatus',
  title: 'Bed Status',
  definition:
    'Value Set of codes that specify the state of a bed in an inpatient setting, and is used to determine if a patient may be assigned to it or not.',
  values: [
    {
      code: 'C',
      display: 'Closed',
      definition: 'Closed',
    },
    {
      code: 'H',
      display: 'Housekeeping',
      definition: 'Housekeeping',
    },
    {
      code: 'O',
      display: 'Occupied',
      definition: 'Occupied',
    },
    {
      code: 'U',
      display: 'Unoccupied',
      definition: 'Unoccupied',
    },
    {
      code: 'K',
      display: 'Contaminated',
      definition: 'Contaminated',
    },
    {
      code: 'I',
      display: 'Isolated',
      definition: 'Isolated',
    },
  ],
};

// http://hl7.org/fhir/ValueSet/location-mode
export const LOCATION_MODE = {
  definingURL: 'http://hl7.org/fhir/ValueSet/location-mode',
  version: '4.3.0',
  name: 'LocationMode',
  title: 'Location Mode',
  definition: 'Indicates whether a resource instance represents a specific location or a class of locations.',
  values: [
  {
    code: 'instance',
    display: 'Instance',
    definition: 'The Location resource represents a specific instance of a Location (e.g. Operating Theatre 1A).',
  },
  {
    code: 'kind',
    display: 'Kind',
    definition:
      'The Location represents a class of locations (e.g. Any Operating Theatre) although this class of locations could be constrained within a specific boundary (such as organization, or parent location, address etc.).',
  },
]};

// http://hl7.org/fhir/ValueSet/location-physical-type
export const LOCATION_PHYSICAL_TYPE = {
  definingURL: 'http://hl7.org/fhir/ValueSet/location-physical-type',
  version: '4.3.0',
  name: 'LocationType',
  title: 'Location Type',
  definition:
    'This example value set defines a set of codes that can be used to indicate the physical form of the Location.',
  values: [
    {
      code: 'si',
      display: 'Site',
      definition: 'A collection of buildings or other locations such as a site or a campus.',
    },
    {
      code: 'bu',
      display: 'Building',
      definition:
        'Any Building or structure. This may contain rooms, corridors, wings, etc. It might not have walls, or a roof, but is considered a defined/allocated space.',
    },
    {
      code: 'wi',
      display: 'Wing',
      definition: 'A Wing within a Building, this often contains levels, rooms and corridors.',
    },
    {
      code: 'wa',
      display: 'Ward',
      definition: 'A Ward is a section of a medical facility that may contain rooms and other types of location.',
    },
    {
      code: 'lvl',
      display: 'Level',
      definition: 'A Level in a multi-level Building/Structure.',
    },
    {
      code: 'co',
      display: 'Corridor',
      definition: 'Any corridor within a Building, that may connect rooms.',
    },
    {
      code: 'ro',
      display: 'Room',
      definition: 'A space that is allocated as a room, it may have walls/roof etc., but does not require these.',
    },
    {
      code: 'bd',
      display: 'Bed',
      definition:
        'A space that is allocated for sleeping/laying on. This is not the physical bed/trolley that may be moved about, but the space it may occupy.',
    },
    {
      code: 've',
      display: 'Vehicle',
      definition: 'A means of transportation.',
    },
    {
      code: 'ho',
      display: 'House',
      definition: 'A residential dwelling. Usually used to reference a location that a person/patient may reside.',
    },
    {
      code: 'ca',
      display: 'Cabinet',
      definition: 'A container that can store goods, equipment, medications or other items.',
    },
    {
      code: 'rd',
      display: 'Road',
      definition: 'A defined path to travel between 2 points that has a known name.',
    },
    {
      code: 'area',
      display: 'Area',
      definition: 'A defined physical boundary of something, such as a flood risk zone, region, postcode',
    },
    {
      code: 'jdn',
      display: 'Jurisdiction',
      definition:
        'A wide scope that covers a conceptual domain, such as a Nation (Country wide community or Federal Government - e.g. Ministry of Health), Province or State (community or Government), Business (throughout the enterprise), Nation with a business scope of an agency (e.g. CDC, FDA etc.) or a Business segment (UK Pharmacy), not just an physical boundary',
    },
  ],
};
